let {getDomain, isReferrerFromVistaprint} = require('./domain'); // not const because of unit tests


const cookieName = 'channel-tracking';
const cookieRetentionPeriodDays = 30;

function initChannelTracking() {
    if (isReferrerFromVistaprint() === false) {
        const data = assembleTrackingData();
        saveTrackingData(data);
    }
}

module.exports = {
    initChannelTracking: initChannelTracking,
    getTrackingData: getTrackingData
};

function assembleTrackingData() {
    const query = new URLSearchParams(window.location.search);

    return {
        "utm_id": query.get('utm_id'),
        "utm_source": query.get('utm_source'),
        "partner": query.get('partner'),
        "referrer": document.referrer,
        "timestamp": Date.now()
    }
}

function saveTrackingData(data) {
    const cookieValue = encodeURIComponent(JSON.stringify(data));

    let expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + cookieRetentionPeriodDays * 24 * 60 * 60 * 1000);
    const expires = '; expires=' + expirationDate.toUTCString();

    const domain = '; domain=' + getDomain();

    document.cookie = cookieName + "=" + cookieValue + expires + domain + "; path=/";
}

function getTrackingData() {
    let data = getCookieValue(cookieName);
    let data_parsed = data ? JSON.parse(data) : {};
    data_parsed.userAgent = window.navigator.userAgent;
    data_parsed.currentPage = window.location.href;
    return data_parsed;
}

function getCookieValue(name) {
    name = name + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookiesArray = decodedCookie.split(';');
    for (let i = 0; i < cookiesArray.length; i++) {
        let cookie = cookiesArray[i];
        while (cookie.charAt(0) == ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) == 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }
    return "";
}